// PostHog event tracking helper.
// PostHog is loaded globally in public/index.html via the snippet,
// so we read it off `window.posthog` and degrade silently if absent
// (dev / blocked-by-adblocker scenarios).

const ph = () =>
  (typeof window !== "undefined" && window.posthog) || null;

/**
 * Track a one-off event.
 * @param {string} name - Event name (snake_case).
 * @param {object} [props] - Event properties.
 */
export const track = (name, props = {}) => {
  const p = ph();
  if (!p || typeof p.capture !== "function") return;
  try {
    p.capture(name, props);
  } catch (err) {
    if (typeof console !== "undefined") console.warn("[analytics] capture failed:", err);
  }
};

/**
 * Register sticky super-properties that ride along with every subsequent event
 * captured in this PostHog session (e.g., last CTA the user clicked).
 * @param {object} props
 */
export const registerSuperProps = (props = {}) => {
  const p = ph();
  if (!p || typeof p.register !== "function") return;
  try {
    p.register(props);
  } catch (err) {
    if (typeof console !== "undefined") console.warn("[analytics] register failed:", err);
  }
};
